import React, { useRef, useEffect } from "react";
import styles from "./styles.module.scss";

/* This element provides "over-scroll" so that the last slide can have its left
hand side flush to the edge of the carousel. This is necessary as snapping the
left hand side of a slide to the edge of the carousel is how we denote jumping
to the index of a particular slide. If we didn't provide this additional padding then the arrow button functionality would potentially be confusing for users on
the last few slides, as depending on their width relative to the carousel
clicking the arrow key might not cause any visual changes.

|Carousel Overflow (not visible)-|Carousel Width-------|
|--------------------------------|-----|---------------|
|------Other Slides--------------|Last-|This Component-|
|--------------------------------|Slide|---------------|
|--------------------------------|-----|---------------|
|--------------------------------|-----|---------------|

*/
const PaddingElement = () => {
  const ref = useRef(null);
  useEffect(() => {
    const carousel = ref.current.parentElement;
    const lastSlide = carousel.children[carousel.children.length - 2];
    const carouselWidth = carousel.clientWidth;
    const lastSlideWidth = lastSlide?.offsetWidth;

    // These values can be missing when the component first mounts, hence the
    // guard clause.
    if (!carouselWidth || !lastSlideWidth) return;

    ref.current.style.width = `${carouselWidth - lastSlideWidth}px`;
  });

  return <div ref={ref} className={styles.paddingElement} />;
};

export default PaddingElement;
